import { render, staticRenderFns } from "./PrestacaoContasFinalDocumentos.vue?vue&type=template&id=e990c5f4&"
import script from "./PrestacaoContasFinalDocumentos.vue?vue&type=script&lang=js&"
export * from "./PrestacaoContasFinalDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports